import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../components/AuthContext';
import usePageMeta from '../utils/usePageMeta';
import logo from '../assets/img/logo2.png';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, loading, error, clearError } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/dashboard';

  usePageMeta({
    title: 'Sign In',
    description: 'Sign in to your Doritostats account to access your ESPN fantasy football analytics.',
    canonical: '/login',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    clearError();
    const result = await login(email, password);
    if (result.success) {
      navigate(from, { replace: true });
    }
  };

  return (
    <main className="min-h-screen bg-bg flex flex-col items-center justify-center px-4">
      {/* Logo */}
      <Link to="/" className="mb-8">
        <img src={logo} alt="Dorito Stats home" className="h-14" />
      </Link>

      <div className="w-full max-w-sm bg-ds-white border border-border-card rounded-card shadow-card p-8">
        <h1 className="font-display text-2xl font-black text-ds-text mb-6">
          Sign in
        </h1>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label className="block text-xs font-bold text-text-muted uppercase tracking-wider mb-1">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              className="w-full border border-border rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-green transition-colors"
              placeholder="you@example.com"
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-text-muted uppercase tracking-wider mb-1">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full border border-border rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-green transition-colors"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <p className="text-coral text-sm font-semibold">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-mustard text-forest font-extrabold text-sm py-2.5 rounded-lg shadow-mustard hover:bg-yellow-500 transition-colors disabled:opacity-60 mt-1"
          >
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <p className="mt-4 text-sm text-text-muted">
          <Link to="/password-reset" className="text-green font-semibold hover:text-mustard transition-colors">
            Forgot password?
          </Link>
        </p>
        <p className="mt-2 text-sm text-text-muted">
          Don't have an account?{' '}
          <Link to="/register" className="text-green font-semibold hover:text-mustard transition-colors">
            Register
          </Link>
        </p>
      </div>
    </main>
  );
};

export default LoginPage;
